import { createContext } from "react"

const TransactionContext = createContext(null)

export default TransactionContext